module.exports = __webpack_public_path__ + "img/next-white-red.1d2c5051.svg";